import React, { useEffect, useState } from 'react';
import { createBillingCheckoutSession, getBillingStatus } from '../../services/api';

function IntelligenceGate({ children }) {
  const [billing, setBilling] = useState(null);
  const [loading, setLoading] = useState(true);
  const [startingCheckout, setStartingCheckout] = useState(false);
  const [error, setError] = useState('');
  const [billingInterval, setBillingInterval] = useState('monthly');

  useEffect(() => {
    let mounted = true;
    getBillingStatus()
      .then((status) => {
        if (mounted) {
          setBilling(status);
          if (!status.available_billing_intervals?.includes('monthly')) {
            setBillingInterval(status.available_billing_intervals?.[0] || 'monthly');
          }
        }
      })
      .catch((err) => {
        if (mounted) setError(err.response?.data?.error || 'Failed to load plan access');
      })
      .finally(() => {
        if (mounted) setLoading(false);
      });
    return () => {
      mounted = false;
    };
  }, []);

  if (loading) return <div className="loading-spinner">Checking plan access...</div>;
  if (billing?.has_intelligence_access) return children;

  const startCheckout = async () => {
    try {
      setStartingCheckout(true);
      setError('');
      const url = await createBillingCheckoutSession(billingInterval);
      window.location.assign(url);
    } catch (err) {
      setError(err.response?.data?.error || 'Checkout is not available yet');
      setStartingCheckout(false);
    }
  };

  return (
    <div className="intelligence-paywall">
      <div className="intelligence-paywall__icon">
        <span className="material-symbols-outlined">auto_awesome</span>
      </div>
      <span className="intelligence-paywall__eyebrow">Risqly Intelligence</span>
      <h1>Turn security signals into prioritized action</h1>
      <p>
        Security Insights is available with Risqly Intelligence. Upgrade to review prioritized
        findings, improvement guidance, detailed external scan results, and recurring security scans.
      </p>
      <div className="intelligence-paywall__features">
        <span><i className="material-symbols-outlined">check_circle</i> Prioritized security findings</span>
        <span><i className="material-symbols-outlined">check_circle</i> Detailed scan evidence</span>
        <span><i className="material-symbols-outlined">check_circle</i> Recurring external integrity scans</span>
        <span><i className="material-symbols-outlined">check_circle</i> 14-day free trial</span>
      </div>
      {billing?.stripe_configured && (
        <div className="billing-interval-toggle" aria-label="Billing interval">
          {['monthly', 'annual'].map((interval) => (
            <button
              type="button"
              key={interval}
              className={billingInterval === interval ? 'is-active' : ''}
              disabled={!billing.available_billing_intervals?.includes(interval)}
              onClick={() => setBillingInterval(interval)}
            >
              {interval === 'monthly' ? 'Monthly' : 'Annual'}
            </button>
          ))}
        </div>
      )}
      <button
        type="button"
        className="btn btn-primary intelligence-paywall__button"
        disabled={startingCheckout || !billing?.stripe_configured}
        onClick={startCheckout}
      >
        {startingCheckout
          ? 'Opening checkout...'
          : billing?.stripe_configured
            ? 'Start free trial'
            : 'Coming soon'}
      </button>
      {!billing?.stripe_configured && (
        <small>Checkout will become available once Risqly Intelligence pricing is configured.</small>
      )}
      {error && <div className="error-text">{error}</div>}
    </div>
  );
}

export default IntelligenceGate;
